import styled from 'styled-components';

const InfoList = styled.ul`
  list-style: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
`;

const Value = styled.span`
  @media (min-width: 640px) {
    align-self: flex-end;
  }
`;

const InfoRow = styled.li`
  border-bottom: 1px dotted ${props => props.theme['grey-normal']};
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
  padding-bottom: 3px;

  @media (min-width: 640px) {
    align-items: center;
    flex-direction: row;
    justify-content: ${
      props => props.alignLeft
        ? 'flex-start'
        : 'space-between'
      };

    ${Value} {
      text-align: ${
        props => props.alignLeft
          ? 'left'
          : 'right'
        };
    }
  }
`;

const Key = styled.span`
  font-weight: ${props => props.light ? 'normal' : 'bold'};

  @media (min-width: 640px) {
    margin-right: 6px;
  }
`;

export {
  InfoList,
  InfoRow,
  Key,
  Value,
};
